import React, {useContext, useEffect} from 'react';
import {ToastContainer} from "react-toastify";
import PublicRoutes from "./routers/publicRoutes";
import PrivateRoutes from "./routers/privateRoutes";
import {LoginContext} from "./context/loginContext";
import {checkAccessTokenCookie} from "./utils/httpServices";
import ScrollToTop from "./components/scrollToTop";
import {fetchDataWithAuth} from "./utils/fetchData";
import config from "./config/apiService.json";
import axios from "axios";

const App = () => {
  const [userLogin, setUserLogin] = useContext(LoginContext);
  const {baseApiEndPoint, home, userValidition} = config;
  const {views} = home;

  const handleAccessTokenCookieValidation = async () => {
    await fetchDataWithAuth(`${userValidition}`);
    return true;
  }

  const increaseVisitor = async () => {
    await axios.post(`${baseApiEndPoint}${views}`)
  }

  useEffect(() => {
    const hasAccessTokenCookie = checkAccessTokenCookie();
    if (hasAccessTokenCookie) {
      const reponse = handleAccessTokenCookieValidation();
      if (reponse) setUserLogin(true);
    }

    increaseVisitor();
  }, []);

  return (
      <>
        <ToastContainer theme="colored"/>
        <ScrollToTop>
          {userLogin ? <PrivateRoutes/> : <PublicRoutes/>}
        </ScrollToTop>
      </>
  );
};

export default App;
